import type { ReactNode } from 'react';

export interface BadgeProps {
  tone?: 'neutral' | 'accent' | 'success' | 'danger' | 'warning';
  children: ReactNode;
}

export function Badge({ tone = 'neutral', children }: BadgeProps) {
  return <span className={`au-badge au-badge--${tone}`}>{children}</span>;
}
